import 'isomorphic-fetch';
import { Product, ProductKeys } from '../../model/wac-signup-form';
import { IStargateClient } from '@atlassiansox/asc-stargate';

export type FreeBreachTestPayloadType = {
  readonly cloudId: string;
  readonly productKeys: string[];
  readonly stargateClient: IStargateClient;
};

export type BreachStatusType = {
  readonly isInBreachOfFree: boolean;
};

const FREE_BREACH_PRODUCTS = [
  ProductKeys.JIRA_SOFTWARE,
  ProductKeys.JIRA_SERVICE_DESK,
  ProductKeys.JIRA_CORE,
  ProductKeys.CONFLUENCE
];

export function computeFreeTrialRedirectURL(selectedSiteId: string) {
  const { origin, pathname, search } = window.location;
  const searchParams = new URLSearchParams(search);
  searchParams.set('edition', 'standard');
  searchParams.set('selectedSiteId', selectedSiteId);
  return `${origin}${pathname}?${searchParams.toString()}`;
}

export function productsCanBeInBreachOfFree(products: Product[]) {
  const productsCanBeInBreach = products.reduce(
    (allProductsAreEligible: boolean, product: Product) => {
      return (
        allProductsAreEligible &&
        FREE_BREACH_PRODUCTS.includes(product.product as ProductKeys) &&
        product.edition === 'free'
      );
    },
    true
  );

  return productsCanBeInBreach;
}

export async function checkBreachStatus({
  cloudId,
  productKeys,
  stargateClient
}: FreeBreachTestPayloadType) {
  const { isInBreachOfFree } = await stargateClient.postExpandFreeValidation({
    cloudId,
    productKeys
  });

  return isInBreachOfFree;
}
